import React from "react";
import styled from "styled-components";
import Loader from "components/UI/Loader";
import { useHistory } from "react-router-dom";

const Container = styled.div`
  margin-top:4rem;
  table{
    margin-top:2rem;
  }
`;

const InvoiceLineGrid = ({ invoiceId, items }) => {
  const history = useHistory();
 
  const open = (id) => {   
    history.push("/admin/invoices/" + invoiceId + "/" + id);
  };

  return (
    <Container> 
     <label>Factuurlijnen</label>
     <table cellSpacing="500">
        <thead>
          <tr>            
            <th></th>
            <th>Omschrijving</th>
            <th>Aantal</th>
            <th>Totaal (excl. btw)</th>
            <th>Btw</th>
            <th>Totaal (incl. btw)</th>
          </tr>
        </thead>
        <tbody>
        {!items 
          ? <Loader center />
           : <> 
              {items.map((item, idx) => (          
                  // <tr key={item.id + '_' + idx} onClick={() => open(item.id)} className="clickable">       
                  <tr key={item.id + '_' + idx}>           
                    <td>{item.reference}</td>            
                    <td>{item.description}</td>        
                    <td>{item.quantity}</td>    
                    <td>{"€" + item.totalPriceVatExcluded}</td>             
                    <td>{"€" + item.vat}</td>       
                    <td>{"€" + item.totalPriceVatIncluded}</td>               
                  </tr>      
              ))}
             </>
        }
        </tbody>
      </table>
    </Container>
  );
};

export default InvoiceLineGrid;
